(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["enea-collection-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('enea-collection-description')) {
    customElements.define('enea-collection-description', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.enhance(), { once: true });
        } else {
          this.enhance();
        }
      }

      enhance() {
        if (this.dataset.enhanced || !this.isConnected) return;
        this.body = this.querySelector('.enea-cd__body');
        this.toggle = this.querySelector('.enea-cd__toggle');
        if (!this.body || !this.toggle || !this.body.textContent.trim()) return;
        this.dataset.enhanced = 'true';
        this.open = false;
        this.measure();
        if (!this.collapsedHeight) return;
        this.toggle.addEventListener('click', () => (this.open ? this.collapse() : this.expand()));
        this.body.addEventListener('transitionend', (event) => {
          if (event.target !== this.body || event.propertyName !== 'max-height') return;
          if (this.open) this.body.style.maxHeight = 'none';
        });
        let frame;
        window.addEventListener('resize', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => { if (!this.open) this.measure(); });
        });
      }

      lineHeight() {
        const probe = this.body.querySelector('p, li, div') || this.body;
        const value = parseFloat(getComputedStyle(probe).lineHeight);
        return Number.isFinite(value) && value > 0 ? value : parseFloat(getComputedStyle(probe).fontSize) * 1.55;
      }

      measure() {
        const mobile = window.matchMedia('(max-width: 767px)').matches;
        const lines = parseInt(mobile ? this.dataset.linesMobile || this.dataset.lines : this.dataset.lines, 10) || 4;
        const line = this.lineHeight();
        const collapsed = Math.round(line * lines);
        const previous = this.body.style.maxHeight;
        this.body.style.maxHeight = 'none';
        const full = this.body.scrollHeight;
        this.body.style.maxHeight = previous;
        // Only clamp when at least one extra line is hidden; a few words are not worth a control.
        if (full <= collapsed + line) {
          this.collapsedHeight = 0;
          this.body.style.maxHeight = 'none';
          delete this.dataset.clamped;
          this.toggle.hidden = true;
          return;
        }
        this.collapsedHeight = collapsed;
        this.body.style.maxHeight = collapsed + 'px';
        this.style.setProperty('--enea-cd-fade', Math.round(line * (mobile ? 1.4 : 1.7)) + 'px');
        this.dataset.clamped = 'true';
        this.toggle.hidden = false;
      }

      expand() {
        this.open = true;
        this.body.style.maxHeight = this.body.scrollHeight + 'px';
        this.dataset.open = 'true';
        this.toggle.setAttribute('aria-expanded', 'true');
      }

      collapse() {
        this.open = false;
        this.body.style.maxHeight = this.body.scrollHeight + 'px';
        void this.body.offsetHeight;
        this.body.style.maxHeight = this.collapsedHeight + 'px';
        delete this.dataset.open;
        this.toggle.setAttribute('aria-expanded', 'false');
        const top = this.getBoundingClientRect().top;
        if (top < 0) {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
